import { localStorage } from '@redbubble/persistent-storage';
export var buildAmplitudeExperimentTrackingTrait = function (amplitudeExperiments) {
    if (!amplitudeExperiments)
        return [];
    return Object.entries(amplitudeExperiments).map(function (_a) {
        var id = _a[0], enrolment = _a[1].enrolment;
        return ({
            id: id,
            assigned: enrolment,
            exposed: localStorage.getItem(id) !== null,
        });
    });
};
